"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserGlobals = getBrowserGlobals;
exports.isBrowser = isBrowser;
exports.isSSR = isSSR;
exports.onBrowser = onBrowser;
exports.onSSR = onSSR;
/**
 * @todo Add fbjs utils as dependency and replace with canUseDOM
 * @link https://github.com/facebook/fbjs/blob/main/packages/fbjs/src/core/ExecutionEnvironment.js
 */
function isBrowser() {
  var _window, _window$document;
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  return !!(typeof window !== 'undefined' && (_window = window) !== null && _window !== void 0 && (_window$document = _window.document) !== null && _window$document !== void 0 && _window$document.createElement);
}
function isSSR() {
  return !isBrowser();
}
function onSSR(callback, otherwise) {
  return isSSR() ? callback() : otherwise === null || otherwise === void 0 ? void 0 : otherwise();
}
function onBrowser(callback, otherwise) {
  return isBrowser() ? callback() : otherwise === null || otherwise === void 0 ? void 0 : otherwise();
}
/**
 * Gets browser builtin globals in an server-side-rendering-safe way
 *
 * @returns The globals if in a browser environment, or undefined if in a
 * SSR environment
 */
function getBrowserGlobals() {
  return isSSR() ? undefined : {
    window,
    document
  };
}